/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { appInsights } from "../shared/services/application-insights/telemetry";

/* eslint-disable @typescript-eslint/no-explicit-any, no-console -- delegates to console only when logging is enabled */
const shouldLog = process.env.NODE_ENV === "development";

export const log = (message?: any, ...optionalParams: any[]) => {
  if (shouldLog) {
    console.log(message, ...optionalParams);

    appInsights.trackTrace({
      message: message,
      properties: optionalParams,
      severityLevel: 0 /* Verbose */,
    });
  }
};

export const warn = (message?: any, ...optionalParams: any[]) => {
  if (shouldLog) {
    console.warn(message, ...optionalParams);

    appInsights.trackTrace({
      message: message,
      properties: optionalParams,
      severityLevel: 2 /* Warning */,
    });
  }
};

export const error = (message?: any, ...optionalParams: any[]) => {
  appInsights.trackException({
    exception: new Error(message),
    properties: optionalParams,
    severityLevel: 3 /* Error */,
  });
};

export const info = (message?: any, ...optionalParams: any[]) => {
  if (shouldLog) {
    console.info(message, ...optionalParams);

    appInsights.trackTrace({
      message: message,
      properties: optionalParams,
      severityLevel: 1 /* Information */,
    });
  }
};

export const debug = (message?: any, ...optionalParams: any[]) => {
  if (shouldLog) {
    console.debug(message, ...optionalParams);
  }
};
